import { Suspense } from "react";
import { lazyWhenVisible } from "@/lib/lazy-visible";
import { SectionHeading } from "./SectionHeading";
import LeadFormStatic from "./LeadForm";

// O formulário completo sai no HTML; o JavaScript dele (validação, máscaras,
// seletores) só carrega quando a seção se aproxima da tela.
const LeadForm = import.meta.env.SSR
  ? LeadFormStatic
  : lazyWhenVisible("inscricao", () => import("./LeadForm"));

export function FormSection() {
  return (
    <section id="inscricao" className="relative scroll-mt-20 bg-charcoal py-12 md:py-16">
      <div className="container-narrow">
        <SectionHeading
          eyebrow="Começar"
          title="Vamos montar o seu programa."
          subtitle="Preencha em 1 minuto. Na próxima tela você recebe o link seguro de pagamento e, logo depois, agenda a conversa de 20 minutos onde definimos a agenda das 4 sessões."
        />

        <Suspense fallback={null}>
          <LeadForm />
        </Suspense>
      </div>
    </section>
  );
}
